/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    blockquote: "blockquote",
    a: "a",
    pre: "pre",
    h4: "h4",
    strong: "strong"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "css"
      }), " 属性(", _jsx(_components.code, {
        children: "css"
      }), " prop)"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "css"
      }), " prop"]
    }), "\n", _jsx(_components.p, {
      children: "| v4"
    }), "\n", _jsxs(_components.p, {
      children: ["有时你不想仅仅为了应用一些样式而创建额外的组件。", _jsx(_components.code, {
        children: "css"
      }), " 属性是一种迭代组件的便捷方法，而无需确定固定的组件边界。它适用于普通 HTML 标签和组件，并支持任何样式组件支持的所有内容，包括基于 props、主题和自定义组件进行调整。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Sometimes you don't want to create an extra component just to apply a bit of styling. The ", _jsx(_components.code, {
        children: "css"
      }), " prop is a convenient way to iterate on your components without settling on fixed component boundaries yet. It works on both normal HTML tags as well as components, and supports everything any styled component supports, including adapting based on props, theming and custom components."]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["要启用对 ", _jsx(_components.code, {
          children: "css"
        }), " 属性的支持，你必须使用 ", _jsx(_components.a, {
          href: "/docs/tooling#babel-plugin",
          children: "Babel 插件"
        }), "。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥To enable support for the ", _jsx(_components.code, {
          children: "css"
        }), " prop you have to use the ", _jsx(_components.a, {
          href: "/docs/tooling#babel-plugin",
          children: "Babel plugin"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "<div\n  css={`\n    background: papayawhip;\n    color: ${props => props.theme.colors.text};\n  `}\n/>\n<Button\n  css=\"padding: 0.5em 1em;\"\n/>\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["在底层，Babel 插件将任何带有 ", _jsx(_components.code, {
        children: "css"
      }), " prop 的元素转换为样式组件。例如上面的代码就变成："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Under the hood, the Babel plugin turns any element with a ", _jsx(_components.code, {
        children: "css"
      }), " prop into a styled component. For example, the above code becomes:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-javascript",
        children: "import styled from 'styled-components';\n\nconst StyledDiv = styled.div`\n  background: papayawhip;\n  color: ${props => props.theme.colors.text};\n`\n\nconst StyledButton = styled(Button)`\n  padding: 0.5em 1em;\n`\n\n<StyledDiv />\n<StyledButton />\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "请注意，你甚至不必添加导入，Babel 插件会自动执行此操作！（除非你使用 Babel 宏，请参见下文）"
    }), "\n", _jsx(_components.p, {
      children: "¥Note that you don't even have to add the import, the Babel plugin does that automatically! (unless you're using the Babel macro, see below)"
    }), "\n", _jsx(_components.h4, {
      children: "与 Babel 宏一起使用(Usage with the Babel macro)"
    }), "\n", _jsx(_components.p, {
      children: "¥Usage with the Babel macro"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["由于缺乏使用和其他消费者不必要的膨胀，此功能在 v6.1 中被删除。", _jsx(_components.a, {
          href: "https://github.com/styled-components/styled-components/issues/4064",
          children: "更多信息"
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["¥This functionality was removed in v6.1 due to lack of usage and unnecessary bloat for other consumers. ", _jsx(_components.a, {
          href: "https://github.com/styled-components/styled-components/issues/4064",
          children: "More info"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["你可以使用 ", _jsx(_components.a, {
        href: "/docs/tooling#babel-macro",
        children: "Babel 宏"
      }), " 在 ", _jsx(_components.code, {
        children: "create-react-app"
      }), " 中完成此操作。不幸的是，Babel 宏仅在导入时运行，因此无法自动添加导入。如果你手动将导入添加到宏，则上述代码可以完美运行："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can use the ", _jsx(_components.a, {
        href: "/docs/tooling#babel-macro",
        children: "Babel macro"
      }), " to make this work in ", _jsx(_components.code, {
        children: "create-react-app"
      }), ". Unfortunately, Babel macros only run when imported so ", _jsx(_components.strong, {
        children: "the import can not be added automatically."
      }), " The above code works perfectly if you add the import to the macro manually:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled from 'styled-components/macro'\n\n<div\n  css={`\n    background: papayawhip;\n    color: ${props => props.theme.colors.text};\n  `}\n/>\n<Button\n  css=\"padding: 0.5em 1em;\"\n/>\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "与 TypeScript 一起使用(Usage with TypeScript)"
    }), "\n", _jsx(_components.p, {
      children: "¥Usage with TypeScript"
    }), "\n", _jsxs(_components.p, {
      children: ["为了防止任意元素上的 ", _jsx(_components.code, {
        children: "css"
      }), " 属性出现 TypeScript 错误，请安装 ", _jsx(_components.code, {
        children: "@types/styled-components"
      }), " 并在项目中添加以下导入："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To prevent TypeScript errors on the ", _jsx(_components.code, {
        children: "css"
      }), " prop on arbitrary elements, install ", _jsx(_components.code, {
        children: "@types/styled-components"
      }), " and add the following import once in your project:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "import {} from 'styled-components/cssprop'\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["请参阅 ", _jsx(_components.a, {
        href: "https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31245#issuecomment-446011384",
        children: "https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31245#issuecomment-446011384"
      }), " 了解更多信息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥See ", _jsx(_components.a, {
        href: "https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31245#issuecomment-446011384",
        children: "https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31245#issuecomment-446011384"
      }), " for more information."]
    }), "\n", _jsxs(_components.p, {
      children: ["如果你使用的版本高于 v6，则无需安装 ", _jsx(_components.code, {
        children: "@types/styled-components"
      }), "。相反，你可以直接在项目中导入 ", _jsx(_components.code, {
        children: "CSSProp"
      }), "，如下所示："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you're using a higher version than v6, you do not need to install ", _jsx(_components.code, {
        children: "@types/styled-components"
      }), ".\nInstead, you can directly import the ", _jsx(_components.code, {
        children: "CSSProp"
      }), " in your project like this:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "import {} from 'react'\nimport type { CSSProp } from 'styled-components'\n\ndeclare module 'react' {\n  interface Attributes {\n    css?: CSSProp | undefined\n  }\n}\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
